import { PaginationResponse } from '@wilson/base';
import { WithTranslations } from '../translations';
import { QualificationCategoryIdsMap } from './UserQualification';

export interface QualificationV2 extends WithTranslations {
  id: string;
  createdAt: string;
  deletedAt: string | null;
  locationId: string | null;
  organizationalUnitId: string | null;
  qualificationCategoryId: string;
  routeId: string | null;
  substitutableQualificationIds: string[];
  updatedAt?: string | null;
  vehicleModelId: string | null;
}

export type SimpleQualificationV2 = Pick<
  QualificationV2,
  'id' | 'nameDe' | 'nameEn' | 'nameFr' | 'namePl' | 'qualificationCategoryId'
>;

export type GetQualificationV2 = PaginationResponse<QualificationV2>;

export type GetQualificationV2Grouped = PaginationResponse<{
  category: string;
  items: QualificationV2[];
}>;

export const SelectedQualificationCategoryFilterIds = [
  QualificationCategoryIdsMap.Location,
  QualificationCategoryIdsMap.Vehicle,
  QualificationCategoryIdsMap.Training,
  QualificationCategoryIdsMap.SafetyCertificate,
  QualificationCategoryIdsMap.Certificate,
  QualificationCategoryIdsMap.Country,
  QualificationCategoryIdsMap.DriverLicense,
  QualificationCategoryIdsMap.Language,
  QualificationCategoryIdsMap.MedicalExamination,
  QualificationCategoryIdsMap.More,
  QualificationCategoryIdsMap.Vehicle,
  QualificationCategoryIdsMap.SafetyCertificate,
  QualificationCategoryIdsMap.MedicalExamination,
  QualificationCategoryIdsMap.FurtherEducation,
];
